import * as React from 'react';
import { FieldProps } from '../metadataFormField';
import { FieldGroup } from '../FieldGroup/fieldGroup';
import { getFieldValue } from '../../../utils';

export const BooleanField = (props: FieldProps) => {
  const { field, data, updater } = props;
  const { updateField, updateData } = updater;
  const value = getFieldValue(field, data);
  return (
    <FieldGroup {...props} value={value ? 'true' : 'false'}>
      <input
        type="checkbox"
        checked={value}
        onChange={() => {
          updateField(field, !value);
          updateData(field, !value);
        }}
      />
    </FieldGroup>
  );
};
